var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('h5',[_vm._v("Relatorios")])]),_c('b-card-body')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }